import { setupFilterMultiSelects, buildFilters } from './schedule-five-overview-filters';

export const TITLE_WIDTH = 350 + 32;
export const TOTAL_WIDTH = 120;

const _refreshers = [];

export const registerSummaryGridRefresher = (fn) => {
    _refreshers.push(fn);
};

const _syncSelectors = [
    '.s5-totals-wrap .k-grid-content',
    '.s5-previous-month-wrap .k-grid-content',
    '.s5-variance-wrap .k-grid-content',
    '.s5-cost-code-wrap .k-grid-content',
];

const _wrapSelectors = [
    '.s5-totals-wrap',
    '.s5-previous-month-wrap',
    '.s5-variance-wrap',
    '.s5-cost-code-wrap',
];

export const initSummaryFilterCoordinator = (company) => {
    setupFilterMultiSelects('js-summary', company);

    $('.js-summary-apply-filters').on('click', () => {
        const filters = buildFilters('js-summary');
        _wrapSelectors.forEach(sel => kendo.ui.progress($(sel), true));
        return Promise.all(_refreshers.map(fn => fn(filters)))
            .then(() => syncScrolls(..._syncSelectors))
            .finally(() => _wrapSelectors.forEach(sel => kendo.ui.progress($(sel), false)));
    });
};

let _syncTeardown = null;

export const syncScrolls = (...selectors) => {
    if (typeof document === 'undefined') return () => {};

    _syncTeardown?.();

    const elements = selectors.map(sel => document.querySelector(sel)).filter(el => el != null);

    const handlers = elements.map((el, i) => {
        const handler = () => {
            elements.forEach((other, j) => {
                if (j !== i) other.scrollLeft = el.scrollLeft;
            });
        };
        el.addEventListener('scroll', handler);
        return { el, handler };
    });

    _syncTeardown = () => {
        handlers.forEach(({ el, handler }) => el.removeEventListener('scroll', handler));
    };

    return _syncTeardown;
};
